export const EXAM = [
  {
    title: 'GENERAL_ANESTHESIA',
    value: 'GENERAL_ANESTHESIA',
  },
  {
    title: 'SPINAL',
    value: 'SPINAL',
  },
  {
    title: 'EPIDURAL',
    value: 'EPIDURAL',
  },
  {
    title: 'PEDIATRIK',
    value: 'PEDIATRIK',
  },
  {
    title: 'PENYULIT',
    value: 'PENYULIT',
  },
  {
    title: 'PERIPHERAL_BLOK',
    value: 'PERIPHERAL_BLOK',
  },
  {
    title: 'KOMPREHENSIF',
    value: 'KOMPREHENSIF',
  },
];

export const EXAM_TYPE = [
  {
    title: 'Teori',
    value: 'TEORI',
  },
  {
    title: 'Praktek',
    value: 'PRAKTEK',
  },
];
